import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import warningSvg from "../assets/icons/warning.svg";
import { toast } from 'react-toastify';
import store from "../Store/index"
import { setIsShowTransactionExpiredModal } from '../Store/Reducers/mainReducer';
import { setErrorModal } from "../Store/Reducers/errorReducer";
import { FaCheck } from "react-icons/fa";
import { HiShieldExclamation } from "react-icons/hi";
import { IoWarningSharp } from "react-icons/io5";
import { FaInfoCircle } from "react-icons/fa";
import { setCancelUrl } from '../Store/Reducers/userReducer';

// const getAlertType = (type, cb, error) => {
//   if (!type) { cb.error(error) };
//   switch (type) {
//     case 'info':
//       return cb.info(error, { position: toast.POSITION.BOTTOM_LEFT });
//     case 'success':
//       return cb.success(error, { position: toast.POSITION.BOTTOM_LEFT });
//     case 'warning':
//       return cb.warning(error, { position: toast.POSITION.BOTTOM_LEFT });
//     case 'error':
//       return cb.error(error, { position: toast.POSITION.BOTTOM_LEFT });
//     default:
//       break;
//   }
// }

const getAlertType = (type, cb, error) => {
  if (!type) {
    cb.error(error);
  }
  switch (type) {
    case "info":
      return cb.info(error, { icon: <FaInfoCircle size={20} /> });
    case "success":
      return cb.success(error, { icon: <FaCheck size={22} /> });
    case "warning":
      return cb.warning(error, { icon: <IoWarningSharp size={25} /> });
    case "error":
      return cb.error(error, { icon: <HiShieldExclamation size={25} /> });
    default:
      break;
  }
};

export default class AlertService {

  // static alert = (type, error, errorType = "") => {
  //   let message = "Something went wrong";
  //   if (typeof error === "object") {
  //     if (error.message || error.respmess) {
  //       message = error.message || error.respmess;
  //     } else {
  //       const errors = error.errors?.Error;
  //       if (errors && errors.length > 0) {
  //         errors.forEach((error) => {
  //           const errorParams = error.params;
  //           if (errorParams) {
  //             if (errorParams.ErrorNumber === "104") {
  //               store.dispatch(setIsShowTransactionExpiredModal(true));
  //             } else {
  //               if (errorParams.ErrorNumber) {
  //                 message = <span>
  //                   <p className='mb-0'>{errorParams?.Description || errorParams?.Message}</p>
  //                   <p className='mb-0'>Error Number: {errorParams?.ErrorNumber}</p>
  //                 </span>
  //               } else {
  //                 message = errorParams?.Description || errorParams?.Message;
  //               }
  //             }
  //           }
  //         });
  //       } else {
  //         message = "Unrecognized error";
  //       }
  //     }
  //   } else if (typeof error === "string") {
  //     message = error;
  //   }
  //   if (type === "error") {
  //     store.dispatch(setErrorModal({ show: true, message, errorType }));
  //   } else {
  //     getAlertType(type, toast, message);
  //   }
  // };


  static alert = (type, error, errorType = "") => {
    let message = "Something went wrong";

    if (typeof error === "string") {
      message = error;
    } else if (typeof error === "object" && error !== null) {
      if (error.message || error.respmess) {
        message = error.message || error.respmess;
      } else {
        const errors = error.errors?.Error;
        if (Array.isArray(errors) && errors.length > 0) {
          for (const err of errors) {
            const params = err?.params;

            if (!params) continue;

            // ❌ Transaction expired
            if (params.ErrorNumber === "104") {
              store.dispatch(setCancelUrl(null));
              store.dispatch(setIsShowTransactionExpiredModal(true));
              return; // ⬅️ ВАЖНО: полностью выходим
            }

            if (params.ErrorNumber) {
              message = (
                <span>
                  <p className="mb-0">
                    {params.Description || params.Message}
                  </p>
                  <p className="mb-0">
                    Error Number: {params.ErrorNumber}
                  </p>
                </span>
              );
              break;
            }

            // обычное текстовое сообщение
            if (params.Description || params.Message) {
              message = params.Description || params.Message;
              break;
            }
          }
        } else {
          message = "Unrecognized error";
        }
      }
    }
    if (type === "error") {
      store.dispatch(setErrorModal({ show: true, message, errorType }));
    } else {
      getAlertType(type, toast, message);
    }
  };


  static alertConfirm = (title, message, yes, no) => {
    return new Promise((resolve, reject) => {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert">
              <div className="react-confirm-alert-body">
                <div className='react-confirm-alert-title-block'>
                  <img className='mr-2' src={warningSvg} alt="" />
                  {
                    title ? <h3>{title}</h3> : null
                  }
                  <hr />
                </div>
                {
                  message ?
                    <>
                      <p>{message}</p>
                      <hr />
                    </>
                    : null
                }
                <div className="react-confirm-alert-button-group justify-content-end">
                  <button onClick={() => { reject(); onClose(); }}>{no}</button>
                  <button onClick={() => { resolve(); onClose(); }}>{yes}</button>
                </div>
              </div>
            </div>
          )
        }
      })
    })
  }

}
